<main class="mds-grid mds-grid-cols-1">
  <mc-card heading="Login" subheading="Test the SSO Broker login flow">
      <mc-input 
          id="email"
          label="Email"
          hint="Email domain will be parsed and matched against a configured tenant"
          name="email"
          type="email"
          [value]="email()"
          (input)="onInput($event)"
          (keydown.enter)="lastHint()?.available ? startLogin() : checkHint()">
      </mc-input>
    <mc-button slot="actions" appearance="primary" (click)="startLogin()" [disabled]="!directVisible()" [loading]="checking()">Sign in with SSO</mc-button>
    <div slot="footer" [hidden]="!hintVisible()">
      <mc-notification [appearance]="hintAppearance()">{{ hintMessage() }}</mc-notification>
    </div>
  </mc-card>

  @if (lastHint()) {
    <app-code-block [content]="lastHint() | json"></app-code-block>
  }
</main>